import React from 'react';
import { Tooltip } from './Tooltip';

export const Input = ({ label, id, error, helpText, className = '', type = 'text', highlight, ...props }) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label htmlFor={id} className="text-xs font-semibold text-brand-muted uppercase tracking-wider flex items-center">
          {label}
          {helpText && <Tooltip text={helpText} />}
        </label>
      )}
      <input
        id={id}
        type={type}
        className={`w-full px-4 py-2.5 bg-brand-light/30 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent/20 transition-all text-sm
          ${error || highlight ? 'border-red-400 bg-red-50/30 ring-1 ring-red-400/20' : 'border-brand-border focus:border-brand-accent'}`}
        {...props}
      />
      {error && <span className="text-[10px] font-medium text-red-500 mt-1 uppercase tracking-tight">{error}</span>}
    </div>
  );
};

export const Textarea = ({ label, id, error, helpText, className = '', highlight, ...props }) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label htmlFor={id} className="text-xs font-semibold text-brand-muted uppercase tracking-wider flex items-center">
          {label}
          {helpText && <Tooltip text={helpText} />}
        </label>
      )}
      <textarea
        id={id}
        className={`w-full px-4 py-3 bg-brand-light/30 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent/20 transition-all text-sm min-h-[100px] resize-y
          ${error || highlight ? 'border-red-400 bg-red-50/30 ring-1 ring-red-400/20' : 'border-brand-border focus:border-brand-accent'}`}
        {...props}
      />
      {error && <span className="text-[10px] font-medium text-red-500 mt-1 uppercase tracking-tight">{error}</span>}
    </div>
  );
};